export interface ScreenViewParameters {
  /**
   * Screen name the user is currently viewing.
   */
  screen_name?: string;
  /**
   * Current class associated with the view the user is currently viewing.
   */
  screen_class?: string;
  /**
   * Custom event parameters.
   */
  [key: string]: any;
}

export async function logAnalyticsScreenView(params: ScreenViewParameters) {
  // TODO: implement web analytics
  // For mobile app implementation see `analytics.native.ts`
}

export async function logAnalyticsEvent(
  eventName: string,
  params?: { [key: string]: any }
) {
  // For mobile app implementation see `analytics.native.ts`
}

export async function resetAnalyticsData() {
  // For mobile app implementation see `analytics.native.ts`
}
